var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.249108 12.2135C1.2828 16.7668 5.33012 19.9986 9.99929 19.9989C12.3318 19.9979 14.5907 19.1824 16.386 17.6933L15.7473 16.9237C12.0538 19.9882 6.60615 19.6183 3.36074 16.0828C0.115336 12.5472 0.212194 7.08785 3.58098 3.66962C6.94976 0.251382 12.4071 0.0749831 15.9896 3.26853C19.5721 6.46207 20.0213 11.9037 17.011 15.6415L17.7903 16.2685C20.7175 12.6308 20.7375 7.45156 17.8384 3.79142C14.9394 0.131281 9.89316 -1.03525 5.68186 0.9812C1.47055 2.99765 -0.784589 7.66019 0.249108 12.2135ZM9.48421 10.2263L13.2272 14.9293L14.0092 14.3063L10.4852 9.87931L10.4982 4.00231L9.49821 4.00031L9.48421 10.2263Z",
    fill: "#B2B2B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/Timer.375b712ea2595cb794828cf6c8693739.svg";
export { ForwardRef as ReactComponent };